<script>
import {writable} from 'svelte/store';
import {getCookie} from '../utils/cookies';

import {Button, Alert} from 'sveltestrap';
import {ListGroup, ListGroupItem} from 'sveltestrap';
import {Modal, ModalBody, ModalFooter} from 'sveltestrap';
import {user} from '../store/User.js';
import ModalBox from '../ui/ModalBox.svelte';
import {alert} from '../store/ModalBox';
import { addToast } from "../store/Toasts.js";

export let img_src = '';
export let allow_self_register = true;
export let allow_remember_me = true;

function hashCode(s) {
    var hash = 0, i, chr;
    if (s.length === 0) return hash;
        for (i = 0; i < s.length; i++) {
        chr   = s.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}


let root;
let username, password = '';
let reg = {
    name: '',
    email: '',
    password: '',
    password2: ''
};
let recover = {
    email: ''
};

let registration_error = writable([]);

let current = {page: 'login'}; // can also be 'register', 'recover'

let accept_agreement;

let charte_open=false;

function toggleCharteModal() { charte_open = !charte_open; }

function authentify() {
    if (!accept_agreement) {
        user.set_error("Pour vous connecter, vous devez accepter la charte d'utilisation des services WebDiabete");
        return;
    }
    user.authentify(username, password, "/"); // third argument to reload the page
}

function register() {
    registration_error.update(function(old) { return []; });

    fetch(
        '/api/register',
        {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": "true",
                "credentials": "include",
                "X-XSRF-TOKEN": decodeURIComponent(getCookie('XSRF-TOKEN')),
            },
            body: JSON.stringify(reg),
        }
    ).then(r=>r.json())
    .then(r => {
        if (r.success) {
            username = reg.email;
            password = '';
            user.reset();
            current.page = 'login';
        } else {
            registration_error.update(() => {
                let arr = {};
                for(let t in r.message) {
                    arr[t] = [];
                    for (let tt in r.message[t]) {
                        arr[t].push({
                            id: t + "_" + (arr[t].length + 1) + "_" + hashCode(r.message[t][tt]),
                            text: r.message[t][tt]
                        });
                    }
                }
                return arr;
            });
        }
    });
}

function recover_password() {
    if (recover.email.trim()=="") {
        alert("Erreur", "Vous devez fournir l'adresse email utilisée lors de votre inscription");
        return;
    }


    if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(recover.email.trim())) {
        fetch(
            '/api/get_recover_password_link',
            {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Credentials": "true",
                    "credentials": "include",
                    "X-XSRF-TOKEN": decodeURIComponent(getCookie('XSRF-TOKEN')),
                },
                body: JSON.stringify({"email": recover.email.trim()}),
            }
        ).then(r => r.json())
        .then(r => {
            if (r.success) {
                addToast({
                    message: r.message,
                    type: "success",
                    dismissible: true,
                    timeout: 3000,
                });
                recover.email = "";
            } else {
                alert("Erreur", r.message);
            }
        });
    } else {
        alert("Erreur", `L'adresse email <b>${recover.email.trim()}</b> n'est pas valide`);
        return;
    }


}
</script>

<div class="d-flex flex-column justify-content-center h-100" bind:this={root}>
    <div class="container">
        <div class="row">
        {#if img_src!=''}
            <div class="col-md-6">
                <img src={img_src} alt="Image" class="img-fluid">
            </div>
        {/if}

        {#if current.page=='login'}
            <div class="col-md-6 contents">
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        {#if $user.error}
                        <Alert color='danger'>{$user.error}</Alert>
                        {/if}
                        <div class="mb-4">
                            <h3><i class="fas fa-lock"></i>&nbsp;Connexion</h3>
                            <p class="mb-4">Bienvenue sur votre espace personnel Webdiabete.<br>Vous devez d'abord vous connecter.</p>
                        </div>
                        <div class="form-group first">
                            <label for="">Nom d'utilisateur</label>
                            <input type="text" class="form-control" bind:value={username}>
                        </div>
                        <div class="form-group last mb-4">
                            <label for="">Mot de passe</label>
                            <input type="password" class="form-control" bind:value={password}>
                        </div>
                        {#if allow_remember_me==true}
                        <div class="d-flex mb-5 justify-content-between">
                            <label class="control control--checkbox mb-0"><span class="caption">Se souvenir de moi</span>
                                <input type="checkbox" checked />
                                <div class="control__indicator"></div>
                            </label>
                        </div>
                        {/if}
                        <div class="mb-5 form-check">
                            <input type="checkbox" class="form-check-input" bind:checked={accept_agreement} />
                            <label class="form-check-label mb-0" for="#">J'ai lu et j'accepte la <a href="#" on:click={toggleCharteModal}>charte d'utilisation des services WebDiabete</a></label>
                        </div>
                        <div class="d-flex mb-5 justify-content-between">
                            <Button color="primary" on:click={authentify}>Se connecter</Button>

                        {#if allow_self_register==true}
                            <span class="ml-auto"><a href="#" on:click={() => {current.page='register'} }>M'enregistrer</a></span>
                        {/if}

                            <span class="ml-auto"><a href="#" on:click={() => {current.page='lost_password'} }>Mot de passe perdu ?</a></span>
                        </div>
                    </div>
                </div>
            </div>
        {:else if (current.page=='register')}
            <div class="col-md-6 contents">
                <div class="row justify-content-center">
                    <div class="col-md-8">

                        <div class="mb-4">
                            <h3><i class="fas fa-lock"></i>&nbsp;Création de compte</h3>
                            <p class="mb-4">Lorem ipsum dolor sit amet elit. Sapiente sit aut eos consectetur adipisicing.</p>
                        </div>

                        <div class="form-group mb-1">
                            <label for="reg.name">Nom</label>
                            <input type="text" class="form-control mb-1" id="reg.name" bind:value={reg.name}>
                        </div>
                        <div class="registration-error-alert">
                        {#if "name" in $registration_error}
                            <ListGroup>
                            {#each $registration_error.name as item, index (item.id)}
                                <ListGroupItem color="danger">{item.text}</ListGroupItem>
                            {/each}
                            </ListGroup>
                        {/if}
                        </div>

                        <div class="form-group mb-1">
                            <label for="">Email</label>
                            <input type="email" class="form-control mb-1" bind:value={reg.email}>
                        </div>
                        <div class="registration-error-alert">
                        {#if "email" in $registration_error}
                            <ListGroup>
                            {#each $registration_error.email as item, index (item.id)}
                                <ListGroupItem color="danger">{item.text}</ListGroupItem>
                            {/each}
                            </ListGroup>
                        {/if}
                        </div>

                        <div class="form-group mb-1">
                            <label for="">Mot de passe</label>
                            <input type="password" class="form-control" bind:value={reg.password}>
                        </div>
                        <div class="registration-error-alert">
                        {#if "password" in $registration_error}
                            <ListGroup>
                            {#each $registration_error.password as item, index (item.id)}
                                <ListGroupItem color="danger">{item.text}</ListGroupItem>
                            {/each}
                            </ListGroup>
                        {/if}
                        </div>

                        <div class="form-group mb-1">
                            <label for="">Confirmation du mot de passe</label>
                            <input type="password" class="form-control" bind:value={reg.password2}>
                        </div>
                        <div class="registration-error-alert">
                        {#if "password2" in $registration_error}
                            <ListGroup>
                            {#each $registration_error.password2 as item, index (item.id)}
                                <ListGroupItem color="danger">{item.text}</ListGroupItem>
                            {/each}
                            </ListGroup>
                        {/if}
                        </div>

                        <div class="d-flex mb-5 justify-content-between">
                            <Button color="primary" on:click={register}>S'enregistrer</Button>
                            <span class="ml-auto"><a href="#"  on:click={() => {current.page='login'} }>Se connecter</a></span>
                            <span class="ml-auto"><a href="#" on:click={() => {current.page='lost_password'} }>Mot de passe perdu ?</a></span>
                        </div>
                    </div>
                </div>
            </div>
        {:else if (current.page=='lost_password')}
            <div class="col-md-6 contents">
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <div class="mb-4">
                            <h3><i class="fas fa-key"></i>&nbsp;Récupérer mon mot de passe</h3>
                            <p class="mb-4">Veuillez nous fournir l'adresse email avec laquelle vous êtes enregistré sur WebDiabete.</p>
                        </div>
                        <div class="form-group mb-4">
                            <label for="">Email</label>
                            <input type="email" class="form-control mb-1" bind:value={recover.email}>
                        </div>
                        <div class="mb-4">
                            <p class="mb-4">Nous vous enverrons un lien temporaire vous permettant de changer votre mot de passe.</p>
                        </div>
                        <div class="d-flex mb-5 justify-content-between">
                            <Button color="primary" on:click={recover_password}>Envoyer un lien</Button>
                            <span class="ml-auto"><a href="#"  on:click={() => {current.page='login'} }>Se connecter</a></span>
                            {#if allow_self_register==true}
                                <span class="ml-auto"><a href="#" on:click={() => {current.page='register'} }>M'enregistrer</a></span>
                            {/if}
                        </div>



                    </div>
                </div>
            </div>

        {/if}
        </div>

    </div>
</div>

<ModalBox></ModalBox>

<Modal isOpen={charte_open} toggle={toggleCharteModal} scrollable fullscreen={true}>
    <ModalBody>
        <p style="width:100%; border: solid black 0px;">

        </p><h1 align="center">CHARTE D’UTILISATION DU SITE WEBDIABETE</h1>
        <h3 align="right">version 4.0 – juin 2011</h3>
          
        
        
        
        Le site «Webdiabete» est une plateforme Web 2.0 qui permet la transmission et le partage d’informations notamment celles concernant votre diabète. Le site à pour vocation de faciliter votre vie quotidienne en vous permettant, en tant que patient, d’envoyer, si vous le souhaitez de partager et de recevoir des informations et/ou conseils utiles au suivi de votre maladie.<br>
        
        La plateforme se propose, pour cela, de vous permettre :
        <ul>
        <li> <b>transmettre simplement vos résultats</b> et messages à la plateforme sécurisée et d’y visualiser vos résultats de façon synthétique,</li>
        <li> d’envoyer un message via une connexion sécurisée</li>
        <li> de <b>garder un contact rapide, fiable et simple</b> avec le professionnel de santé qui vous suit habituellement (infirmière à domicile, médecin de famille, médecin spécialiste) dans le cadre du protocole de soins prévu lors d’une consultation préalable,</li>
        <li> d’avoir accès à un conseil spécialisé quelque soit votre lieu d’habitation et  vos difficultés de déplacement </li>
        <li> éventuellement, de décharger votre lecteur et  transférer de façon sécurisée ces données vers le site</li>
        </ul>
        Une fois inscrit et avec votre autorisation, votre professionnel de santé, peut accéder à ces données:-  de façon synthétique, claire et informative 
        <ul>
        <li> et vous donner ainsi des conseils adaptés.</li>
        </ul>
        <br>
        <br>
        <b>Ces services ont pour but de compléter les consultations et non de s’y substituer.</b> Seuls les patients déja en consultation et régulièrement suivis en consultation ou en hospitalisation se voient offrir la possibilité d’utiliser le site.
        <br><br>
        <b>Principe n° 1 – Les destinataires des données</b><br>
        Sur le site, seul votre (vos) professionnel(s) de santé peu(ven)t répondre à vos questions. La réponse qui ne peut qu’être complémentaire par rapport à une consultation, se fait dans un délai à définir avec votre professionnel de santé. 
        Tous les utilisateurs de la plate-forme ainsi que les modérateurs s’engagent à se comporter en tout temps avec respect et honnêteté. 
        En cas de manquement à cet engagement, le site se réserve le droit de retirer sans délai et sans compensation, les droits d’accès à un utilisateur.
        Le site se réserve le droit d’un traitement statistique anonyme de ces données.
        <br><br>
        <b>Principe n° 2 – Complémentarité/ Mission /Audience/ Modalités d'inscription  </b><br>
        Le site ne vise et <b>ne peut en aucun cas</b>  se substituer à une consultation réelle avec vos professionnels de santé habituels. Seuls les patients déjà vus une première fois en consultation de diabétologie et régulièrement suivis se voient offrir la possibilité d’utiliser le site.
        <br><br>
        <b>Principe n° 3 – Confidentialité, droit d’accès et de rectification aux données</b><br>
        Tout message est confidentiel : il ne peut qu’être lu que par le médecin auquel il est adressé ainsi qu’éventuellement par votre infirmière et/ou médecin traitant habituels. Pour ces derniers, vous pouvez vous opposer à la transmission de ces informations en cochant la case appropriée sur votre interface personnelle.
        Une fois envoyé, vos propres messages sont stockés sur la plateforme et ne peuvent plus ni être modifiés, ni effacés. 
        L’utilisateur peut par le biais de son interface personnelle et sécurisée :
        <ul>
        <li> accéder aux informations le concernant et modifier ces informations en ligne</li>
        <li>se mettre fin à sa souscription en remplissant le formulaire adhoc à confirmer dans un délai d’un mois par envoi d’un courrier recommandé avec AR au siège de l’association Webdiabete, 46, av de St Amand 59300 Valenciennes</li>
        </ul>
        <b>Principe n°4</b><br>
        Les patients utilisateurs de la plate-forme s’engagent à transmettre l’intégralité des informations les concernant nécessaires à la réponse prodiguée. Dans le cas contraire, il ne pourra être reproché au professionnel de santé une réponse inadaptée.
        Tous les messages des utilisateurs sont automatiquement identifiés (nom du rédacteur/identifiant de connexion), datés et stockés dans une base de données. Le site se réserve le droit d’un traitement statistique anonyme de ces données afin d’améliorer le service proposé ainsi que d’évaluer l’impact du Télésuivi sur l’état de santé des patients participants.
        <br><br>
        
        <b>Principe n° 5</b><br>
        Il est stipulé que tous les utilisateurs de la plate-forme s'engagent à ne diffuser que des informations qui sont vraies et correctes au vu de leurs connaissances. 
        L’utilisation de la plateforme est conditionnée par l’accord à la présente charte qui en fixe les règles d’utilisation. En y souscrivant vous devenez également membre utilisateur de l’association et pourrez si vous le souhaitez participez à l’amélioration de la plateforme
        <br><br>
        
        <b>Principe n° 6</b><br>
        Les réponses sont traitées par le professionnel de sante et sont confidentielles. Elles peuvent être transmises, sauf refus de votre part, à votre médecin traitant +/- infirmière habituel(le)s afin d’améliorer le suivi.
        <br><br>
        
        <b>Principe n° 7</b><br>
        Le modérateur est votre professionnel de santé habituel pour les informations transmises. 
        <br><br>
        
        <b>Principe n° 8</b><br>
        La plateforme n’a pas vocation à publier de la publicité, que ce soit sous forme de contenu ou de liens. 
        <br><br>
        
        Le site a été crée à l’initiative de l’association loi 1901 Webdiabete avec le soutien le soutien du ministère de l’enseignement supérieur et de la recherche et d’organismes privés.
        Vous pouvez contacter le webmaster à l’adresse suivante : <a href="mailto:contact@webdiabete.net">contact@webdiabete.net</a>
        <br><br>
        
        <div class="row"><div class="text-center">guidelines Web 2.0 - version 4.0 – juin 2011</div></div>
        
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" on:click={toggleCharteModal}>Fermer</Button>
    </ModalFooter>
  </Modal>